import MillOverview from "../../pages/mill-overview";
import SawlineOverview from "../../pages/sawlines";
import WeldlineOverview from "../../pages/weldlines";

export const routeOverviewWeld165 = "/overview/Weld165";
export const routeOverviewSawEast = "/overview/SawEast";
export const routeOverviewMill = "/overview/Mill";
export const routeOverviewPattern = "/overview/:assetName";

export const overviewRoutes = [
	// Static routes must be declared before the :assetName pattern.
	{
		path: routeOverviewSawEast,
		element: <SawlineOverview />,
	},
	{
		path: routeOverviewMill,
		element: <MillOverview />,
	},
	{
		path: routeOverviewPattern,
		element: <WeldlineOverview />,
	},
];
